
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

import keyStore, { notificationType } from "Store/keyStore";
import { INotifyParameter } from "Helpers/notification";

const notificationDefault: INotifyParameter = {
  type: notificationType.success,
  description: "",
  buttonText: "OK",
  image: "",
};

export default defineComponent({
  data() {
    return {
      toggle: false,
    };
  },
  computed: {
    ...mapGetters({
      notification_getters: keyStore.NOTIFICATION,
    }),
    notification() {
      const notifyGetters = this.notification_getters as INotifyParameter;
      var notify = Object.assign({}, notificationDefault, notifyGetters);
      notify.image = this.getImg(notify.type == notificationType.success);
      return notify;
    },
  },
  methods: {
    getImg(success: boolean) {
      const rootPath = this.publicPath;
      if (success) {
        return rootPath + "img/interface1@2x.png";
      }
      return rootPath + "img/interface2@2x.png";
    },
    onClick() {
      this.toggle = false;
      const callBack = this.notification.callBack;
      if (callBack != null) {
        callBack();
      }
    },
  },
  watch: {
    notification: function (newValue) {
      if (!!newValue) {
        this.toggle = true;
      }
    },
  },
});
